import { render, staticRenderFns } from "./PersonnelDetails.vue?vue&type=template&id=30781edb"
import script from "./PersonnelDetails.vue?vue&type=script&lang=js"
export * from "./PersonnelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports